import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import { pageTitle } from '../../../util/pageTitles';
import { Helmet } from 'react-helmet-async';
import _ from 'lodash';

import Header from '../../../components/Header/Header';
import { updateStepData } from '../SubscribeActions';
import { Plans, Confirmation, Dashboards } from '../components';

import { getCustomerBilling } from '../../Billing/BillingActions';

import './../Subscribe.scss';

class Upgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1
    };
  }

  componentDidMount() {
    if (!this.props.customer.plan) {
      this.props.getCustomerBilling();
    } else {
      this.setModel();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customer != this.props.customer) {
      this.setModel();
    }
  }

  componentWillUnmount() {
    this.props.updateStepData({});
  }

  setModel() {
    const model = {
      currentPlan: this.props.customer.subscription.plan_id,
      planId: this.props.customer.subscription.plan_id,
      firstName: this.props.customer.customer.billing_address.first_name,
      lastName: this.props.customer.customer.billing_address.last_name,
      country: this.props.customer.customer.billing_address.country,
      company: this.props.customer.customer.billing_address.company,
      coupon: this.props.customer.subscription.coupon
    };

    if (this.props.customer.card) {
      model.card = {
        lastFour: this.props.customer.card.last4,
        cardType: this.props.customer.card.card_type
      };
    }

    this.props.updateStepData(model);
  }

  render() {
    const { step } = this.state;

    return (
      <div>
        <Helmet>
          <title>{pageTitle('Billing')}</title>
        </Helmet>
        <Header showHome={true} buttons={[]} />
        <div className='subscribe_content'>
          <div className='indicator'>
            <div className={`item ${step > 2 && 'passed'} ${step < 3 && 'active' }`}>
              {step === 2 ? 
                <React.Fragment><span className='number'>1</span> Remove dashboards</React.Fragment> 
                : <React.Fragment><span className='number'>1</span> Select plan</React.Fragment>}
            </div>
            <div className={`item ${step === 3 && 'active'}`}><span className='number'>2</span> Confirm subscription</div>
          </div>
          {step === 1 && <Plans isUpgrade={true} onNext={step => this.setState({ step })} />}
          {step === 2 && (
            <Dashboards onNext={() => this.setState({ step: 3 })} onBack={() => this.setState({ step: 1 })} />
          )}
          {step === 3 && <Confirmation isUpgrade={true} onBack={() => this.setState({ step: 1 })} />}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateStepData: model => dispatch(updateStepData(model)),
    getCustomerBilling: () => dispatch(getCustomerBilling())
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    outside: state.app.outside,
    reqSent: state.subscription.sent,
    customer: state.billing.customer,
    user: state.auth.user
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Upgrade));
